import Api from "../utils/axios";

export const AdvertisementApi = {
    createAdvertisement: (payload) => Api.post("/advertise/create-advertisement", payload,{headers:{"Content-Type":"multipart/form-data"}}),
    updateAdvertisement: (payload, id) => Api.put(`/advertise/update-advertisement/${id}`, payload,{headers:{"Content-Type":"multipart/form-data"}}),
    getAdvertisementById: (id) => Api.get(`/advertise/get-advertisement-by-id/${id}`),
    getAllAdvertisement: (payload,search="") => Api.post(`/advertise/get-all-advertisements?search=${search}`,payload),
    deleteAdvertisement: (id) => Api.delete(`/advertise/delete-advertisement/${id}`)
};